<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="pV"></a><i>This book is dedicated to those who helped me recover from serious injury, especially Gill Alcock, Mr Chris Armistead, Jane Hardman, Dr Meg Hardman, Dr Richard Hardman, Colonel Robert Hardman, Sheila Hardman, Joy Jones, Patrick Jones, Pam Lamb, Sheryl Millington, Jacqui Moore, Alan Peachment, Jane Platt, Professor Harry Procter, Jane Procter, Hazel Todhunter, Peter Todhunter and Barbara Wyatt.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?8307f458